import { KnownProjectFeature, ProjectDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { BookingFlowType } from '../../ui/enums/booking-flow-type.enum';

/**
 * Determines booking flow type for a given project based on its enabled features
 * @param project The project to check
 * @returns BookingFlowType.INVENTORY if the project's enabledFeatures includes
 *          ProjectFeature.InventoryBookingFlow, BookingFlowType.RETAIL otherwise
 */
export function getBookingFlowType(project: ProjectDto | undefined): BookingFlowType {
  if (project?.enabledFeatures?.includes(KnownProjectFeature.InventoryBookingFlow)) {
    return BookingFlowType.INVENTORY;
  }

  return BookingFlowType.RETAIL;
}

export function isRetailFlow(project: ProjectDto | undefined): boolean {
  return getBookingFlowType(project) === BookingFlowType.RETAIL;
}

export function isInventoryFlow(project: ProjectDto | undefined): boolean {
  return getBookingFlowType(project) === BookingFlowType.INVENTORY;
}
